import { render, staticRenderFns } from "./substitutionClass.vue?vue&type=template&id=27677ec9&"
import script from "./substitutionClass.vue?vue&type=script&lang=js&"
export * from "./substitutionClass.vue?vue&type=script&lang=js&"
import style0 from "./substitutionClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports